// FETCH ALL PROPERTIES FROM ACCESSORIES_DC DETAILS
export const FETCH_ACCESSORIES_DC_DETAILS_REQUEST = 'FETCH_ACCESSORIES_DC_DETAILS_REQUEST';
export const FETCH_ACCESSORIES_DC_DETAILS_SUCCESS = 'FETCH_ACCESSORIES_DC_DETAILS_SUCCESS';
export const FETCH_ACCESSORIES_DC_DETAILS_FAILURE = 'FETCH_ACCESSORIES_DC_DETAILS_FAILURE';

// FETCH ALL PROPERTIES FROM ACCESSORIES_DC DETAILS BY ID
export const FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST = 'FETCH_ACCESSORIES_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_ACCESSORIES_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_ACCESSORIES_DC_DETAILS_BY_ID_FAILURE = 'FETCH_ACCESSORIES_DC_DETAILS_BY_ID_FAILURE';

// CREATE PROPERTIES FOR ACCESSORIES_DC DETAILS
export const CREATE_ACCESSORIES_DC_DETAILS_REQUEST = 'CREATE_ACCESSORIES_DC_DETAILS_REQUEST';
export const CREATE_ACCESSORIES_DC_DETAILS_SUCCESS = 'CREATE_ACCESSORIES_DC_DETAILS_SUCCESS';
export const CREATE_ACCESSORIES_DC_DETAILS_FAILURE = 'CREATE_ACCESSORIES_DC_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ACCESSORIES_DC_DETAILS = 'CREATE_USER_FORM_ACCESSORIES_DC_DETAILS';

// UPDATE PROPERTIES FOR ACCESSORIES_DC DETAILS
export const UPDATE_ACCESSORIES_DC_DETAILS_REQUEST = 'UPDATE_ACCESSORIES_DC_DETAILS_REQUEST';
export const UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS = 'UPDATE_ACCESSORIES_DC_DETAILS_SUCCESS';
export const UPDATE_ACCESSORIES_DC_DETAILS_FAILURE = 'UPDATE_ACCESSORIES_DC_DETAILS_FAILURE';

// FETCH SINGLE ACCESSORIES_DC_DETAILS
export const FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST = 'FETCH_SINGLE_ACCESSORIES_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE = 'FETCH_SINGLE_ACCESSORIES_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR ACCESSORIES_DC DETAILS
export const DELETE_ACCESSORIES_DC_DETAILS_REQUEST = 'DELETE_ACCESSORIES_DC_DETAILS_REQUEST';
export const DELETE_ACCESSORIES_DC_DETAILS_SUCCESS = 'DELETE_ACCESSORIES_DC_DETAILS_SUCCESS';
export const DELETE_ACCESSORIES_DC_DETAILS_FAILURE = 'DELETE_ACCESSORIES_DC_DETAILS_FAILURE';

// USERFORM RESET

export const ACCESSORIES_DC_DETAILS_USERFORM_RESET = 'ACCESSORIES_DC_DETAILS_USERFORM_RESET';
export const ACCESSORIES_DC_DETAILS_USERFORM_SELECTED_ROWS = 'ACCESSORIES_DC_DETAILS_USERFORM_SELECTED_ROWS';

export const FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST = 'FETCH_ACCESSORIES_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_ACCESSORIES_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_ACCESSORIES_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_ACCESSORIES_DC_PREVIOUS_LIST_FAILURE = 'FETCH_ACCESSORIES_DC_PREVIOUS_LIST_FAILURE';

export const UPDATE_ACCESSORIES_DC_REQUEST = 'UPDATE_ACCESSORIES_DC_REQUEST';
export const UPDATE_ACCESSORIES_DC_SUCCESS = 'UPDATE_ACCESSORIES_DC_SUCCESS';
export const UPDATE_ACCESSORIES_DC_FAILURE = 'UPDATE_ACCESSORIES_DC_FAILURE';

export const FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_REQUEST = 'FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_REQUEST';
export const FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_SUCCESS = 'FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_SUCCESS';
export const FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_FAILURE = 'FETCH_ACCESSORIES_DC_DETAILS_GROUP_LIST_FAILURE';

export const FETCH_ACCESSORIES_DC_UPDATE_LIST_REQUEST = 'FETCH_ACCESSORIES_DC_UPDATE_LIST_REQUEST';
export const FETCH_ACCESSORIES_DC_UPDATE_LIST_SUCCESS = 'FETCH_ACCESSORIES_DC_UPDATE_LIST_SUCCESS';
export const FETCH_ACCESSORIES_DC_UPDATE_LIST_FAILURE = 'FETCH_ACCESSORIES_DC_UPDATE_LIST_FAILURE';
